// extracted by mini-css-extract-plugin
export default {"ac-project-employees":"ac-project-employees_ac-project-employees__9Y090","ac-project-employees-list":"ac-project-employees_ac-project-employees-list__paxZC"};